import type Tool from '../../tools/Tool';
import type React from 'react';
import { type Editor } from 'slate';

export type ToolOrToolSet = typeof Tool | (typeof Tool)[];

export interface ToolbarGroupOptions {
  menu: {
    icon: string;
    name: string;
    menuStyle?: 'icon' | 'text' | 'textIcon' | 'component';
    triggerComponent?: React.FC<{ editor: Editor }>;
    tools: ToolOrToolSet[];
  };
}
export interface ToolbarGroup extends ToolbarGroupOptions {
  type: string;
}

export type ToolbarTool = typeof Tool | ToolbarGroup;

export const isToolbarGroup = (tool: ToolbarTool): tool is ToolbarGroup =>
  (tool as ToolbarGroup).type === 'group';
